import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"

interface ExpireOrderProps {
  orderId: string
}

export const useExpireOrderMutation = (
  orderCode: string
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ orderId }: ExpireOrderProps) => {
      const url = `${BASE_URL}${ENDPOINTS.ORDERS}/${orderId}/expire`
      await api.post(url)
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.ORDERS, variables.orderId],
      })
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.RECEIVABLE, variables.orderId],
      })
      await queryClient.invalidateQueries({
        queryKey: [
          "orders",
          { code: orderCode, page: 1, pageSize: 10 },
        ],
      })
    },
  })
}
